import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const propTypes = {
  step: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  next: PropTypes.string
};

const Progress = ({ step, count, title, next, ...props }) => {
  return (
    <Wrapper {...props}>
      <StepCount className="d-flex rounded-circle bg-gray-10">
        <p className="caption text-gray fw-bold">
          {step} of {count}
        </p>
      </StepCount>
      <div className="d-md-flex justify-content-between align-items-center w-100">
        <h4 className={next ? `mb-1 mb-md-0` : ""}>{title}</h4>
        {next && <p className="caption text-gray">Next: {next}</p>}
      </div>
    </Wrapper>
  );
};

/**
 * styles
 */
const StepCount = styled.div`
  width: 3rem;
  height: 3rem;
  flex: 0 0 3rem;

  & > * {
    margin: auto;
  }
`;

const Wrapper = styled.div`
  gap: 1rem;
  display: flex;
  align-items: center;
  padding-bottom: 1rem;
  border-bottom: solid 1px var(--bs-gray-20);

  @media (min-width: 768px) {
    padding-bottom: 1.5rem;
  }
`;

Progress.propTypes = propTypes;

export default Progress;
